(function () {
    function centerCardInContainer(card, container) {
        if (!card || !container) return;
        var containerRect = container.getBoundingClientRect();
        var cardRect = card.getBoundingClientRect();
        var scrollLeft =
            container.scrollLeft +
            (cardRect.left - containerRect.left) -
            (containerRect.width / 2 - cardRect.width / 2);
        container.scrollTo({ left: scrollLeft });
    }

    function selectCard(card) {
        var rowHandle = card.closest('[data-topcard-row]')?.getAttribute('data-topcard-row');
        var topcardHandle = card.getAttribute('data-topcard-handle');
        if (!rowHandle || !topcardHandle) return;

        document.querySelectorAll('[data-topcard-row="' + rowHandle + '"]').forEach(function (row) {
            row.querySelectorAll('.topcard-jul-item.is-selected').forEach(function (el) {
                el.classList.remove('is-selected');
            });
            var match = row.querySelector('[data-topcard-handle="' + topcardHandle + '"]');
            if (!match) return;

            match.classList.add('is-selected');

            var scrollContainer = match.closest('.swiper-wrapper') || match.closest('.topcard-jul-sticky-row');
            centerCardInContainer(match, scrollContainer);
        });
    }

    function parseFilterSpec(spec) {
        if (!spec) return null;
        var separatorIndex = spec.indexOf(':');
        if (separatorIndex === -1) return null;
        return {
            name: spec.slice(0, separatorIndex).trim(),
            value: spec.slice(separatorIndex + 1).trim()
        };
    }

    function getActiveFilterParam() {
        var queryParams = new URLSearchParams(window.location.search);
        var active = null;
        queryParams.forEach(function (value, key) {
            if (!active && key.indexOf('filter.') === 0) {
                active = { name: key, value: value };
            }
        });
        return active;
    }

    function getCurrentCollectionHandle() {
        var el = document.querySelector('[data-default-col-card]');
        var val = el && el.getAttribute('data-default-col-card');
        return val ? val.replace('collection-', '') : null;
    }

    function setCurrentCollectionHandle(handle) {
        var el = document.querySelector('[data-default-col-card]');
        if (el) el.setAttribute('data-default-col-card', 'collection-' + handle);
    }

    function getRowCanonicalHandle(row) {
        var remover = row && row.querySelector('[data-card-type="Filter Remover"]');
        return remover ? remover.getAttribute('data-col-handle') : null;
    }

    function applySelectionFromUrl(row) {
        if (!row) return;

        var activeParam = getActiveFilterParam();
        var cardToSelect = null;
        var matchedFilterCard = false;

        if (activeParam) {
            var filterCards = row.querySelectorAll('[data-filter-specs]');
            for (var i = 0; i < filterCards.length; i++) {
                var parsed = parseFilterSpec(filterCards[i].getAttribute('data-filter-specs'));
                if (parsed && parsed.name === activeParam.name && parsed.value === activeParam.value) {
                    cardToSelect = filterCards[i];
                    matchedFilterCard = true;
                    break;
                }
            }
        }

        if (!cardToSelect) {
            var currentHandle = getCurrentCollectionHandle();
            if (currentHandle) {
                cardToSelect = row.querySelector('[data-col-handle="' + currentHandle + '"]');
            }
        }

        if (!cardToSelect) {
            cardToSelect = row.querySelector('[data-card-type="Filter Remover"]');
        }

        if (cardToSelect) {
            selectCard(cardToSelect);
            if (matchedFilterCard) {
                appendFilterBreadcrumb(getCardTitle(cardToSelect));
            }
        }
    }

    function dispatchParamChange() {
        window.dispatchEvent(new CustomEvent('paramchange', { detail: { message: 'Parameter Change' } }));
    }

    function getCardTitle(card) {
        var title = card.getAttribute('data-card-title');
        if (!title) {
            var textEl = card.querySelector('.topcard-text');
            if (textEl) {
                title = textEl.textContent.trim();
            }
        }
        return (title || '').replace(/\(AB\)/g, '')
                             .replace(/\(Filter\)/g, '')
                             .replace(/\(Top\)/g, '')
                             .replace(/\(Apparel\)/g, '')
                             .replace(/\(HW\)/g, '')
                             .trim()
                             .replace(/^All\s+/, '');
    }

    function pushTopcardClickEvent(collectionHandle, cardTitle) {
        window.VWO = window.VWO || [];
        window.VWO.event = window.VWO.event || function () { window.VWO.push(["event"].concat([].slice.call(arguments))); };
        window.VWO.event("topCardClick", {
            "level1": collectionHandle || "",
            "level2": "",
            "level3": cardTitle || ""
        });
        console.log({
            "level1": collectionHandle || "",
            "level2": "",
            "level3": cardTitle || ""
        });
    }

    function buildDestinationBreadcrumbSegments(colHandle, cardRow, title) {
        var handleDown = colHandle.toLowerCase();

        if (handleDown === 'all' || handleDown === 'shop-all' || handleDown === 'all-products') {
            return [{ text: 'Shop All', href: null }];
        }

        var segments = [{ text: 'Shop All', href: '/collections/shop-all' }];

        var isChildOfUnderwear = false;
        var isChildOfBras = false;

        var cardRowHandle = cardRow ? (cardRow.getAttribute('data-topcard-row') || '').toLowerCase() : '';

        if (cardRowHandle.indexOf('bottom') !== -1 || cardRowHandle.indexOf('underwear') !== -1) {
            isChildOfUnderwear = true;
        } else if (cardRowHandle.indexOf('top') !== -1 || cardRowHandle.indexOf('bralette') !== -1 || cardRowHandle.indexOf('bra') !== -1) {
            isChildOfBras = true;
        }

        if (isChildOfUnderwear && handleDown !== 'underwear') {
            segments.push({ text: 'Underwear', href: '/collections/underwear' });
        } else if (isChildOfBras && handleDown !== 'bralettes-and-tops') {
            segments.push({ text: 'Bras', href: '/collections/bralettes-and-tops' });
        }

        var displayTitle = title;
        if (handleDown === 'underwear') displayTitle = 'Underwear';
        if (handleDown === 'bralettes-and-tops') displayTitle = 'Bras';
        if (handleDown === 'all-support') displayTitle = 'Bras';
        if (handleDown === 'period-protection') displayTitle = 'Period Protection';
        if (handleDown === 'active-collection' || handleDown === 'activewear' || handleDown === 'active') displayTitle = 'Activewear';
        if (handleDown === 'swim-collection' || handleDown === 'swim') displayTitle = 'Swim';
        if (handleDown === 'sleep-collection' || handleDown === 'sleep') displayTitle = 'Sleep';
        if (handleDown === 'apparel-and-accessories' || handleDown === 'apparel' || handleDown === 'accessories') displayTitle = 'Apparel and Accessories';
        if (handleDown === 'new-arrivals' || handleDown === 'new') displayTitle = 'New Arrivals';

        segments.push({ text: displayTitle, href: '/collections/' + colHandle });

        return segments;
    }

    function renderBreadcrumbSegments(segments) {
        var breadcrumbContainer = document.querySelector('.breadcrumb-wrapper.topcart-breadcrumps');
        if (!breadcrumbContainer) return;

        var html = '';
        segments.forEach(function (segment, index) {
            var isLast = index === segments.length - 1;
            if (isLast || !segment.href) {
                var attr = segment.isFilter ? 'data-filter-breadcrumb' : 'data-final-breadcrumb';
                html += '<span ' + attr + ' class="text-capitalize">' + segment.text + '</span>';
            } else {
                var isFilterBase = segments[index + 1] && segments[index + 1].isFilter;
                html += '<a class="text-black bread-link"' + (isFilterBase ? ' data-breadcrumb-filter-remover' : '') + ' href="' + segment.href + '">' + segment.text + '</a> <span> / </span>';
            }
        });
        breadcrumbContainer.innerHTML = html;

        wireFilterRemoverBreadcrumbLink();
    }

    function wireFilterRemoverBreadcrumbLink() {
        var link = document.querySelector('.breadcrumb-wrapper.topcart-breadcrumps [data-breadcrumb-filter-remover]');
        if (!link || link.dataset.wired) return;
        link.dataset.wired = 'true';

        link.addEventListener('click', function (event) {
            var filterRemoverCard = document.querySelector('.topcard-jul-row:not(.d-none) [data-card-type="Filter Remover"]');
            if (!filterRemoverCard) return;

            event.preventDefault();
            handleFilterRemover(filterRemoverCard);
        });
    }

    function getCurrentBreadcrumbSegments() {
        var breadcrumbContainer = document.querySelector('.breadcrumb-wrapper.topcart-breadcrumps');
        if (!breadcrumbContainer) return [];

        var segments = [];
        Array.from(breadcrumbContainer.children).forEach(function (el) {
            if (el.hasAttribute('data-filter-breadcrumb')) return;
            if (el.tagName === 'A') {
                segments.push({ text: el.textContent.trim(), href: el.getAttribute('href') });
            } else if (el.tagName === 'SPAN' && !el.classList.contains('last-divider')) {
                var text = el.textContent.trim();
                if (text && text !== '/') {
                    segments.push({ text: text, href: null });
                }
            }
        });

        if (segments.length) {
            var lastSegment = segments[segments.length - 1];
            if (!lastSegment.href) {
                var currentHandle = getCurrentCollectionHandle();
                if (currentHandle) {
                    lastSegment.href = '/collections/' + currentHandle;
                }
            }
        }

        return segments;
    }

    function updateBreadcrumbs(card) {
        var colHandle = card.getAttribute('data-col-handle');
        if (!colHandle) return;

        var title = getCardTitle(card);
        var cardRow = card.closest('[data-topcard-row]');
        renderBreadcrumbSegments(buildDestinationBreadcrumbSegments(colHandle, cardRow, title));
    }

    function appendFilterBreadcrumb(filterTitle) {
        var segments = getCurrentBreadcrumbSegments();
        if (!segments.length || !filterTitle) return;
        segments.push({ text: filterTitle, href: null, isFilter: true });
        renderBreadcrumbSegments(segments);
    }

    function removeFilterBreadcrumb() {
        var segments = getCurrentBreadcrumbSegments();
        if (!segments.length) return;
        renderBreadcrumbSegments(segments);
    }

    function shouldPreserveTopcardRow(card) {
        return !!document.querySelector('.topcard-ab-b')
            && getCurrentCollectionHandle() === 'shop-all'
            && card.getAttribute('data-topcard-handle') === 'new'
            && card.getAttribute('data-col-handle') === 'new-arrivals';
    }

    function handleOpenNewCard(card) {
        var preserveTopcardRow = shouldPreserveTopcardRow(card);

        selectCard(card);

        var colHandle = card.getAttribute('data-col-handle');
        if (colHandle) {
            setCurrentCollectionHandle(colHandle);
            document.querySelector('.collection-header')?.setAttribute('data-collection-handle', colHandle);
            document.querySelector('.collection-sticky-menu')?.setAttribute('data-collection-handle', colHandle);

            var newUrl = window.location.origin + '/collections/' + colHandle;
            var parsedFilter = parseFilterSpec(card.getAttribute('data-filter-specs'));
            if (parsedFilter) {
                var queryParams = new URLSearchParams();
                queryParams.set(parsedFilter.name, parsedFilter.value);
                newUrl += '?' + queryParams.toString();
            }
            history.replaceState(null, null, newUrl);
        }

        if (!preserveTopcardRow) {
            var childGroupHandle = card.getAttribute('data-child-group');
            if (childGroupHandle) {
                var targetRows = document.querySelectorAll('.topcard-jul-row[data-topcard-row="' + childGroupHandle + '"]');
                if (targetRows.length) {
                    document.querySelectorAll('.topcard-jul-row').forEach(function (row) {
                        row.classList.add('d-none');
                    });
                    targetRows.forEach(function (row) {
                        row.classList.remove('d-none');

                        var swiperEl = row.querySelector('.swiper');
                        if (swiperEl && swiperEl.swiper) {
                            swiperEl.swiper.update();
                        }
                    });
                    applySelectionFromUrl(targetRows[0]);
                }
            }
        }

        if (colHandle) {
            swapProductBundle(colHandle);
            updateBreadcrumbs(card);
        }
    }

    function updateHero(source) {
        if (!source) return;

        var heroTitle = document.querySelector('.collection-hero__title');
        var heroDescription = document.querySelector('.collection-hero__description');

        var title = source.getAttribute('data-hero-title');
        if (heroTitle && title) {
            heroTitle.textContent = title.replace('Bralettes', 'Bras');
        }

        var description = source.getAttribute('data-hero-description');
        if (heroDescription) {
            heroDescription.textContent = description || '';
        }
    }

    function swapProductBundle(colHandle) {
        var targetBundle = document.querySelector('[data-plp-new-structure-products="collection-' + colHandle + '"]');
        if (!targetBundle) return;

        document.querySelectorAll('.collection-bundle').forEach(function (bundle) {
            bundle.classList.add('d-none');
        });
        targetBundle.classList.remove('d-none');

        updateHero(targetBundle);

        dispatchParamChange();
    }

    function applyFilterSpec(spec) {
        var parsed = parseFilterSpec(spec);
        if (!parsed) return;

        var queryParams = new URLSearchParams(window.location.search);

        Array.from(queryParams.keys()).forEach(function (key) {
            if (key.indexOf('filter.') === 0) {
                queryParams.delete(key);
            }
        });
        queryParams.set(parsed.name, parsed.value);

        history.replaceState(null, null, window.location.pathname + '?' + queryParams.toString());
        dispatchParamChange();
    }

    // If this row's canonical collection differs from the collection we're actually
    // on (a style-leaf landing page, e.g. /collections/baller-underwear showing the
    // Boxer Briefs row), filtering in place doesn't make sense - the leaf collection
    // is too narrow to contain sibling styles' products. Redirect to the canonical
    // collection with the filter pre-applied instead.
    function redirectToCanonicalIfNeeded(card, filterSpec) {
        var row = card.closest('.topcard-jul-row');
        var canonicalHandle = getRowCanonicalHandle(row);
        var currentHandle = getCurrentCollectionHandle();

        if (!canonicalHandle || !currentHandle || canonicalHandle === currentHandle) {
            return false;
        }

        var targetUrl = window.location.origin + '/collections/' + canonicalHandle;
        var parsed = parseFilterSpec(filterSpec);
        if (parsed) {
            var queryParams = new URLSearchParams();
            queryParams.set(parsed.name, parsed.value);
            targetUrl += '?' + queryParams.toString();
        }

        window.location.href = targetUrl;
        return true;
    }

    function handleFilter(card) {
        var filterSpec = card.getAttribute('data-filter-specs');
        if (redirectToCanonicalIfNeeded(card, filterSpec)) return;

        selectCard(card);
        applyFilterSpec(filterSpec);
        appendFilterBreadcrumb(getCardTitle(card));
    }

    function handleFilterRemover(card) {
        if (redirectToCanonicalIfNeeded(card, null)) return;

        selectCard(card);

        var queryParams = new URLSearchParams(window.location.search);
        Array.from(queryParams.keys()).forEach(function (key) {
            if (key.indexOf('filter.') === 0) {
                queryParams.delete(key);
            }
        });
        var newSearch = queryParams.toString();
        history.replaceState(null, null, window.location.pathname + (newSearch ? '?' + newSearch : ''));
        dispatchParamChange();
        removeFilterBreadcrumb();
    }

    function handleCardClick(event) {
        var card = event.currentTarget;
        var cardType = card.getAttribute('data-card-type');

        // Hardcoded special case: on New Arrivals, the "Shop All" card always goes to
        // the all-products collection, regardless of its configured type/destination.
        if (window.location.pathname.indexOf('/collections/new-arrivals') === 0 &&
            card.getAttribute('data-topcard-handle') === 'shop-all') {
            event.preventDefault();
            window.location.href = window.location.origin + '/collections/shop-all';
            return;
        }

        if (window.location.pathname.indexOf('/collections/new-arrivals') === 0 &&
            card.getAttribute('data-topcard-handle') === 'new') {
            event.preventDefault();
            window.location.href = window.location.origin + '/collections/new-arrivals';
            return;
        }

        pushTopcardClickEvent(getCurrentCollectionHandle(), getCardTitle(card));

        if (cardType === 'Redirect') {
            return;
        }

        event.preventDefault();

        if (cardType === 'Open New Card') {
            handleOpenNewCard(card);
        } else if (cardType === 'Filter') {
            handleFilter(card);
        } else if (cardType === 'Filter Remover') {
            handleFilterRemover(card);
        }
    }

    function init() {
        document.querySelectorAll('.topcard-jul-row [data-card-type]').forEach(function (card) {
            card.addEventListener('click', handleCardClick);
        });

        applySelectionFromUrl(document.querySelector('.topcard-jul-row:not(.d-none)'));
        wireFilterRemoverBreadcrumbLink();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
